import { useTranslation } from "react-i18next";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { LANGS } from "@/i18n";
import { flagUrl } from "@/lib/flag";
import { useState } from "react";

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = LANGS.find((l) => l.code === (i18n.language || "fr").slice(0, 2)) || LANGS[0];

  const choose = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="flex h-8 items-center gap-1.5 rounded-full px-2 text-sm text-muted-foreground transition-colors hover:text-foreground" aria-label="Langue" data-testid="language-switcher">
          <img src={flagUrl(current.flag)} alt="" className="h-3.5 w-5 rounded-[2px] object-cover shadow-sm" />
          <span className="hidden text-xs uppercase sm:inline">{current.code}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="glass w-44 border-white/10 p-1" data-testid="language-menu">
        {LANGS.map((l) => (
          <button
            key={l.code}
            onClick={() => choose(l.code)}
            className={`flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm transition-colors hover:bg-white/5 ${l.code === current.code ? "text-sky-300" : "text-foreground/90"}`}
            data-testid={`lang-${l.code}`}
          >
            <img src={flagUrl(l.flag)} alt="" className="h-3.5 w-5 rounded-[2px] object-cover shadow-sm" /> {l.label}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
};
